module.exports = __webpack_public_path__ + "static/img/peopleGame4.56200db.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video/peopleGame4.png
// module id = huDI
// module chunks = 3